import { ProcessRun } from '@robocorp/robocloud-orchestrator-interface';
import { WithWorkspaceId } from '~/types/common';
import { WorkspaceProcessRunsByState } from '~/types/resources';
import { dashboardRunApi } from '~/utils/api';

export const getProcessRun = async ({
  workspaceId,
  processId,
  pRunId,
}: {
  processId: string;
  pRunId: string;
} & WithWorkspaceId) =>
  dashboardRunApi.get<ProcessRun>(
    `/workspaces/${workspaceId}/processes/${processId}/runs/${pRunId}`,
  );

export const getWorkspaceProcessRuns = async ({
  workspaceId,
  state,
  excludedStates,
  limit = 10,
  pageCursor,
}: {
  state?: string;
  excludedStates?: string;
  limit?: number;
  pageCursor?: string | null;
} & WithWorkspaceId) =>
  dashboardRunApi.get<WorkspaceProcessRunsByState>(`/workspaces/${workspaceId}/processruns`, {
    state,
    excluded: excludedStates,
    'page[limit]': limit,
    'page[cursor]': pageCursor,
  });

export const startProcessRunByProcessId = async ({
  workspaceId,
  processId,
}: {
  processId: string;
} & WithWorkspaceId) =>
  dashboardRunApi.post<ProcessRun>(`/workspaces/${workspaceId}/processes/${processId}/runs`);
